import { Avatar } from "shared/components/Avatar";
import { BlockQuoteIcon } from "shared/components/Icons";
import { MEDIUM, LARGE } from "shared/utils/constants";
import { MaxWidth } from "shared/components/MaxWidth";
import { Spacing } from "shared/components/Spacing";
import styles from "./QuoteSection.module.css";
import cx from "classnames";

export const QuoteSectionContainer = ({
  cite,
  quote,
  hasBorderbottom = true,
}) => (
  <>
    {!quote ? null : (
      <Spacing size={MEDIUM}>
        <MaxWidth size={LARGE}>
          <QuoteSection
            cite={cite}
            quote={quote}
            hasBorderbottom={hasBorderbottom}
          />
        </MaxWidth>
      </Spacing>
    )}
  </>
);

export const QuoteSection = ({ cite, quote, hasBorderbottom = true }) => (
  <div
    className={cx(styles.container, { [styles.borderBottom]: hasBorderbottom })}
  >
    {quote && (
      <blockquote className={styles.quoteWrapper}>
        <span className={styles.iconWrapper}>
          <BlockQuoteIcon />
        </span>
        {quote && <p className={styles.quote}>{quote}</p>}
      </blockquote>
    )}

    {cite?.name && cite?.image && (
      <div className={styles.avatar}>
        <Avatar
          name={cite?.name}
          titles={[{ title: cite?.title }]}
          image={cite?.image}
          size={LARGE}
        />
      </div>
    )}
  </div>
);
